module.exports = __webpack_public_path__ + "img/idx-title-03.ebdac58.webp";